import { jsx } from 'react/jsx-runtime';
import 'react';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '../../../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/utils';
import '../../../../utils/constants/colors.js';
import 'ethers';
import '../../../../shared/consts/index.js';
import '../../../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/multi-wallet';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '@dynamic-labs/rpc-providers';
import '../../../../context/ErrorContext/ErrorContext.js';
import '../../../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../../../components/IconButton/IconButton.js';
import '@dynamic-labs/wallet-book';
import '../../../../components/Alert/Alert.js';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { OptionsSwitcher } from '../../../../components/OptionsSwitcher/OptionsSwitcher.js';
import '../../../../components/Popper/Popper/Popper.js';
import '../../../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import '../../../../components/MenuList/Dropdown/Dropdown.js';
import { useWidgetContext } from '../../context/DynamicWidgetContext.js';

const options = [
    {
        key: 'index',
        label: 'Wallets',
    },
    {
        key: 'profile',
        label: 'Profile',
    },
];
const DynamicWidgetSwitcher = ({ overwriteValue, }) => {
    const { dynamicWidgetView, setDynamicWidgetView } = useWidgetContext();
    return (jsx(OptionsSwitcher, { rootClassName: 'dynamic-widget-switcher', value: overwriteValue !== null && overwriteValue !== void 0 ? overwriteValue : dynamicWidgetView, options: options, onChange: (view) => setDynamicWidgetView(view) }));
};

export { DynamicWidgetSwitcher };
